document.addEventListener('DOMContentLoaded', () => {
  const faqPage = document.querySelector('.faq-page');
  if (!faqPage) return;

  const searchInput = document.getElementById('faq-search-input') || faqPage.querySelector('.faq-search');
  const searchClearButton = document.getElementById('faq-search-clear');
  const tabButtons = faqPage.querySelectorAll('.faq-tab-button');
  const faqItems = faqPage.querySelectorAll('.faq-item[data-accordion]');

  let currentCategory = 'all';
  let searchTimeout;

  function updateClearButton() {
    if (searchClearButton && searchInput) {
      if (searchInput.value.trim() === '') {
        searchClearButton.classList.add('hidden');
      } else {
        searchClearButton.classList.remove('hidden');
      }
    }
  }

  function filterFAQs() {
    const searchQuery = searchInput ? searchInput.value.trim().toLowerCase() : '';

    let visibleCount = 0;

    faqItems.forEach(item => {
      const category = item.getAttribute('data-category') || '';
      const keywords = item.getAttribute('data-keywords') || '';

      const matchesCategory = currentCategory === 'all' || category === currentCategory;
      const matchesSearch = !searchQuery || keywords.includes(searchQuery);

      if (matchesCategory && matchesSearch) {
        item.classList.remove('hidden');
        item.style.display = '';
        visibleCount++;
        return;
      }
      item.classList.add('hidden');
      item.style.display = 'none';
    });

    let noResultsMsg = faqPage.querySelector('.faq-no-results');
    if (visibleCount === 0) {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement('div');
        noResultsMsg.className = 'faq-no-results text-center py-12 text-gray-500';
        noResultsMsg.textContent = 'No FAQs found matching your criteria.';
        faqPage.appendChild(noResultsMsg);
      }
      noResultsMsg.style.display = 'block';
    } else {
      if (noResultsMsg) {
        noResultsMsg.style.display = 'none';
      }
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      updateClearButton();
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        filterFAQs();
      }, 300);
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') {
        return;
      }
      e.preventDefault();
      clearTimeout(searchTimeout);
      filterFAQs();
    });
  }

  if (searchClearButton) {
    searchClearButton.addEventListener('click', () => {
      if (!searchInput) {
        return;
      }
      searchInput.value = '';
      updateClearButton();
      filterFAQs();
    });
  }

  function scrollTabIntoView(tab) {
    const tabsContainer = document.getElementById('faq-category-tabs');
    if (!tabsContainer) return;

    const containerRect = tabsContainer.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();

    const isFullyVisible =
      tabRect.left >= containerRect.left &&
      tabRect.right <= containerRect.right;

    if (!isFullyVisible) {
      tab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const clickedCategory = button.getAttribute('data-category') || 'all';

      if (currentCategory === clickedCategory && button.getAttribute('data-category-active') === 'true') {
        return;
      }

      currentCategory = clickedCategory;

      tabButtons.forEach(btn => {
        const btnCategory = btn.getAttribute('data-category') || 'all';
        if (btnCategory === currentCategory) {
          btn.classList.remove('bg-white', 'text-black', 'hover:bg-gray-100');
          btn.classList.add('bg-black', 'text-white');
          btn.setAttribute('data-category-active', 'true');
          return;
        }
        btn.classList.remove('bg-black', 'text-white');
        btn.classList.add('bg-white', 'text-black', 'hover:bg-gray-100');
        btn.setAttribute('data-category-active', 'false');
      });

      scrollTabIntoView(button);
      filterFAQs();
    });
  });

  updateClearButton();
  filterFAQs();
});
